import { cn } from '@/lib/utils';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}

export function Card({ children, className, hover = false, ...props }: CardProps) {
  return (
    <div
      className={cn(
        'bg-white backdrop-blur-sm border border-gray-200/80 rounded-2xl p-6 shadow-sm',
        hover && 'hover:border-accent/40 transition-all duration-300 hover:scale-105',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
